export const API_ENDPOINT = window.location.protocol + '//' + window.location.hostname + ':5000/';
export const WS_ENDPOINT = 'ws://' + window.location.hostname +':5001';
export const SNAPSHOT_API_URL = 'http://' + window.location.hostname +':20001/api/v1/stacks/' + process.env.REACT_APP_CAMERA_NAME + '/snapshot';

// local develop
//export const SNAPSHOT_API_URL = 'http://192.168.0.150:20001/api/v1/stacks/RTSPcam00/snapshot';
//export const WS_ENDPOINT = 'ws://192.168.0.150:5001';

